<template>
  <div>
    <nav class="bar bar-nav border" style="margin-left: 0rem" >
      <div style="float: left;width: 88%"> <span style="text-align: center;display: block;margin-top: .5rem">
        个人中心
      </span>
         </div>
      <div style="float: right;width: 12%">
        <a class="item-link item-content" @click='gotoMymessage()' style="float: right; position: relative;margin-top:4px;">
          <!--<label class="icon icon-message"  style="font-size: 1.6rem;" ></label>-->
         <img src="/static/img/kefu.png" style="width: 2.2rem;height: 2rem">
        <span class="unreadmessage" v-if="curMessageSession.unreadMessagesAmount > 0" >
           {{curMessageSession.unreadMessagesAmount}}</span>
        </a>
        <!--<img src="/static/img/kefu.png" style="width: 2.2rem;height: 2rem">-->
        </div>
    </nav>
    <div class="content">
      <div class="list-block media-list person-card" style="margin-top: -2px; margin-bottom: -25px">
        <ul>
          <li>
            <div class="item-content">
              <div class="item-media">
                <img src="./../../assets/timg.jpeg"
                     width="80" style="border-radius: 50%">
              </div>
              <div class="item-inner" style="margin-top: 5px;">
                <div class="item-title-row">
                  <div class="item-title" v-if="sessionInfo.customerNo !== 'GUEST'">{{sessionInfo.customerInfo.customerName}}</div>
                </div>
                <div class="item-subtitle" v-if="sessionInfo.customerNo !== 'GUEST'">{{sessionInfo.customerInfo.customerNo}}</div>
                <div class="item-text" style="height: 1rem;" v-if="sessionInfo.customerNo !== 'GUEST'">{{sessionInfo.customerInfo.enterpriseName}}</div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="row text-center" style="height: 15%;border: 1px solid #ccc;background: white;margin-top: 1.5rem;" v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.ssoFlag === 0">
        <div class="col-20 border" @click="toOrderDetail(1)" style="width: 16%">
          <div class="orderPic icon"><img class="icon-order" src="/emktResources/resocurces/img/icon/not_pay.png"></div>
          <div class="color-gray font-size"><img class="icon-order-pay" :src="baseUrl+'me_pay.png'"></div>
          <span v-if = "myOrder.waitPaidOrders && myOrder.waitPaidOrders.length > 0"
                class= "orderNum">{{myOrder.waitPaidOrders.length}}</span>
        </div>
        <div class="col-20 border" @click="toOrderDetail(2)" style="width: 16%">
          <div class="orderPic icon"><img class="icon-order" src="/emktResources/resocurces/img/icon/not_receive.png"></div>
          <div class="color-gray font-size"><img class="icon-order-pay" :src="baseUrl+'me_receive.png'"></div>
          <span v-if = "myOrder.waitDeliverOrders && myOrder.waitDeliverOrders.length >0"
                class= "orderNum">{{myOrder.waitDeliverOrders.length}}</span>
        </div>
        <!--取消待评论功能-->
        <!--<div class="col-20 border" @click="toEvaluationOrder" style="width: 16%">-->
        <div class="col-20 border" style="width: 16%">
          <div class="orderPic icon"><img class="icon-order" src="/emktResources/resocurces/img/icon/not_comment.png"></div>
          <div class="color-gray font-size"><img class="icon-order-pay" :src="baseUrl+'me_estimate.png'"></div>
          <!--<span v-if = "myOrder.waitCommentMerchandise&& myOrder.waitCommentMerchandise.length >0"-->
                <!--class= "orderNum">{{myOrder.waitCommentMerchandise.length}}</span>-->
        </div>
        <div class="col-20 border" @click="toOrderDetail(3)" style="width: 16%">
          <div class="orderPic icon"><img class="icon-order" src="/emktResources/resocurces/img/icon/complete.png"></div>
          <div class="color-gray font-size"><img class="icon-order-pay" :src="baseUrl+'me_complete.png'"></div>
          <span v-if = "myOrder.finishedOrders&& myOrder.finishedOrders.length >0"
                class= "orderNum">{{myOrder.finishedOrders.length}}</span>
        </div>
        <div class="col-20 border" @click="toOrderDetail(4)" style="width: 16%">
          <div class="orderPic icon"><img class="icon-order" src="/emktResources/resocurces/img/icon/cancel.png"></div>
          <div class="color-gray font-size"><img class="icon-order-pay" :src="baseUrl+'me_cancel.png'"></div>
          <span v-if = "myOrder.canceledOrders && myOrder.canceledOrders.length >0"
                class= "orderNum">{{myOrder.canceledOrders.length}}</span>
        </div>
      </div>
      <div class="row text-center" style="height: 15%;border: 1px solid #ccc;background: white;margin-top: 1.5rem;" v-else>
        <div class="col-20 border" @click="toOrderDetail(10)" style="width: 16%">
          <div class="orderPic icon"><img class="icon-order" src="/emktResources/resocurces/img/icon/not_pay.png"></div>
          <div class="color-gray font-size">审核失败</div>
          <span v-if = "myOrder.failAuditOrders && myOrder.failAuditOrders.length > 0"
                class= "orderNum">{{myOrder.failAuditOrders.length}}</span>
        </div>
        <div class="col-20 border" @click="toOrderDetail(6)" style="width: 16%">
          <div class="orderPic icon"><img class="icon-order" src="/emktResources/resocurces/img/icon/not_pay.png"></div>
          <div class="color-gray font-size">待审核</div>
          <span v-if = "myOrder.waitAuditOrders && myOrder.waitAuditOrders.length > 0"
                class= "orderNum">{{myOrder.waitAuditOrders.length}}</span>
        </div>
        <div class="col-20 border" @click="toOrderDetail(7)" style="width: 16%">
          <div class="orderPic icon"><img class="icon-order" src="/emktResources/resocurces/img/icon/not_receive.png"></div>
          <div class="color-gray font-size">报价完成</div>
          <span v-if = "myOrder.quoteCompletedOrders && myOrder.quoteCompletedOrders.length >0"
                class= "orderNum">{{myOrder.quoteCompletedOrders.length}}</span>
        </div>
        <div class="col-20 border" @click="toOrderDetail(8)" style="width: 16%">
          <div class="orderPic icon"><img class="icon-order" src="/emktResources/resocurces/img/icon/not_comment.png"></div>
          <div class="color-gray font-size">录入完成</div>
          <span v-if = "myOrder.completeOrders && myOrder.completeOrders.length >0"
                class= "orderNum">{{myOrder.completeOrders.length}}</span>
        </div>
        <div class="col-20 border" @click="toOrderDetail(9)" style="width: 16%">
          <div class="orderPic icon"><img class="icon-order" src="/emktResources/resocurces/img/icon/complete.png"></div>
          <div class="color-gray font-size">待签署</div>
          <span v-if = "myOrder.waitSignOrders && myOrder.waitSignOrders.length >0"
                class= "orderNum">{{myOrder.waitSignOrders.length}}</span>
        </div>
        <div class="col-20 border" style="width: 16%">
          <div class="orderPic icon"><img class="icon-order" src="/emktResources/resocurces/img/icon/cancel.png"></div>
          <div class="color-gray font-size">报价作废</div>
        </div>
      </div>
      <div class="list-block" style="display: block;margin-top: 0.2rem;">
        <ul>
          <li>
            <router-link :to="{ name: 'userInfo' }" class="item-link item-content">
              <div class="item-media"><i class="icon icon-me"></i></div>
              <div class="item-inner">
                <div class="item-title">个人信息</div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'VipPlanDetails' }" class="item-link item-content">
              <div class="item-media"><i class="icon icon-me"></i></div>
              <div class="item-inner">
                <div class="item-title">我的大客户计划</div>
              </div>
            </router-link>
          </li>
          <li v-if="!isSFFlag">
            <router-link :to="{ name: 'ResearchGroupHome' }" class="item-link item-content">
              <div class="item-media">
                <i class="icon icon-me"></i>
              </div>
              <div class="item-inner">
                <div class="item-title">我的课题组</div>
                <div class="item-title-after wait-approve" v-if="totalWaitApproveOrder">{{totalWaitApproveOrder}}</div>
              </div>
            </router-link>
          </li>
          <li v-if="myCoupons.length != 0">
            <div class="item-content">
              <div class="item-media"><i class="icon icon-gift"></i></div>
              <div class="item-inner">
                <div class="item-title">我的优惠券</div>
                <div class="item-title-after font-size">
                  <router-link :to="{ name: 'myCoupons' }" >共{{myCoupons.length}}张优惠券
                    <span style="color:#ff0000;font-size:.6rem;" v-if="expireInOneDay">优惠券即将过期</span>
                  </router-link>
                </div>
              </div>
            </div>
          </li>
          <li v-else>
            <div class="item-content">
              <div class="item-media"><i class="icon icon-gift"></i></div>
              <div class="item-inner">
                <div class="item-title">我的优惠券</div>
                <div class="item-title-after font-size" >无</div>
              </div>
            </div>
          </li>
          <li>
            <router-link :to="{ name: 'myRecommend' }" class="item-link item-content">
              <div class="item-media"><i class="icon icon-browser"></i></div>
              <div class="item-inner">
                <div class="item-title">推荐给好友</div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link class="item-link item-content" :to="{ name: 'passwordChange' }">
              <div class="item-media"><i class="icon icon-edit"></i></div>
              <div class="item-inner">
                <div class="item-title">修改密码</div>
              </div>
            </router-link>
          </li>

          <!--<li>-->
            <!--<router-link class="item-link item-content" :to="{ name: 'changeLoginId' }">-->
              <!--<div class="item-media"><i class="icon icon-edit"></i></div>-->
              <!--<div class="item-inner">-->
                <!--<div class="item-title">修改手机（未完成）</div>-->
              <!--</div>-->
            <!--</router-link>-->
          <!--</li>-->
          <li>
            <router-link class="item-link item-content" :to="{ name: 'WeappAddress' }">
              <div class="item-media"><i class="icon icon-edit"></i></div>
              <div class="item-inner">
                <div class="item-title">收货地址管理</div>
              </div>
            </router-link>
          </li>
          <!--<li>-->
            <!--<router-link class="item-link item-content" :to="{ name: 'WeappInvoiceAddress' }">-->
              <!--<div class="item-media"><i class="icon icon-edit"></i></div>-->
              <!--<div class="item-inner">-->
                <!--<div class="item-title">发票寄送地址</div>-->
              <!--</div>-->
            <!--</router-link>-->
          <!--</li>-->
          <!--<li>-->
            <!--<router-link class="item-link item-content" :to="{ name: 'WeappInvoiceTitle' }">-->
              <!--<div class="item-media"><i class="icon icon-edit"></i></div>-->
              <!--<div class="item-inner">-->
                <!--<div class="item-title">发票抬头管理</div>-->
              <!--</div>-->
            <!--</router-link>-->
          <!--</li>-->
        </ul>
      </div>
      <div class="list-block" style="display: block;margin-top: -25px;">
        <ul>
          <li>
            <div class="item-content">
              <div class="item-media"><i class="icon icon-star"></i></div>
              <div class="item-inner">
                <div class="item-title">我的信用</div>
                <div class="item-title-after font-size" v-if="creditPay">
                  {{ sessionInfo.customerInfo.emktCreditBalance | currencyStyle }}
                </div>
                <div class="item-title-after font-size" v-else-if="creditStatus === 0">
                  <router-link :to="{ name: 'applyCreditPay'}">申请信用支付</router-link>
                </div>
                <div class="item-title-after font-size" v-else>
                  {{ payTypeApplyStatus }}
                  <!--<router-link :to="{ name: 'applyCreditPay'}">重新申请</router-link>-->
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-media"><i class="icon icon-emoji"></i></div>
              <div class="item-inner">
                <div class="item-title">我的余额</div>
                <div class="item-title-after font-size" v-if="moneyRemain">
                  {{sessionInfo.customerInfo.prepayMoneyRemain | currencyStyle}}
                </div>
                <div class="item-title-after font-size" v-else>
                  {{0 | currencyStyle}}
                </div>
              </div>
            </div>
          </li>

<!--          <li>-->
<!--            <div class="item-content">-->
<!--              <div class="item-media"><i class="icon icon-gift"></i></div>-->
<!--              <div class="item-inner">-->
<!--                <div class="item-title">我的积分</div>-->
<!--                &lt;!&ndash;<div class="item-title-after font-size" v-if="sessionInfo.creditPoint">&ndash;&gt;-->
<!--                  &lt;!&ndash;{{sessionInfo.creditPoint}}&ndash;&gt;-->
<!--                &lt;!&ndash;</div>&ndash;&gt;-->
<!--                &lt;!&ndash;<div class="item-title-after font-size" v-else>&ndash;&gt;-->
<!--                  &lt;!&ndash;@click="getPointsDetail()"&ndash;&gt;-->
<!--                  &lt;!&ndash;&lt;!&ndash;<a href="http://genechem-customer.xinfuli.net/web/login">积分兑换 </a>&ndash;&gt;&ndash;&gt;-->
<!--                &lt;!&ndash;</div>&ndash;&gt;-->
<!--                <button class="item-title-after font-size" style="color: #399FED"   @click="getPointsDetail()">-->
<!--                  查看积分-->
<!--                </button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </li>-->
                    <li v-if="showBillInfo">
                      <div class="item-content">
                        <div class="item-media"><i class="icon icon-search"></i></div>
                        <div class="item-inner">
                          <div class="item-title">我的对账单</div>
                          <!--<div class="item-title-after font-size" v-if="sessionInfo.creditPoint">-->
                            <!--{{sessionInfo.creditPoint}}-->
                          <!--</div>-->
                          <!--<div class="item-title-after font-size" v-else>-->
                            <!--@click="getPointsDetail()"-->
                            <!--&lt;!&ndash;<a href="http://genechem-customer.xinfuli.net/web/login">积分兑换 </a>&ndash;&gt;-->
                          <!--</div>-->
                          <button class="item-title-after font-size" style="color: #399FED"   @click="getMyAccountChecked()">
                            查看对账单
                          </button>
                        </div>
                      </div>
                    </li>
        </ul>
      </div>

      <div class="list-block" style="display: block;margin-top: -25px;">
        <ul>
          <li>
            <router-link :to="{ name: 'myAgreement' }" class="item-link item-content">
              <div class="item-media"><i class="icon icon-menu"></i></div>
              <div class="item-inner">
                <div class="item-title">注册协议</div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="list-block" style="display: block;margin-top: -25px;">
        <ul>
          <li>
            <router-link :to="{ name: 'contact' }" class="item-link item-content">
              <div class="item-media"><i class="icon icon-message"></i></div>
              <div class="item-inner">
                <div class="item-title">联系我们</div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="list-block" style="display: block;margin-top: -25px;">
        <ul>
          <li>
            <router-link :to="{ name: 'publicNumber' }" class="item-link item-content">
              <div class="item-media"> <i class="icon icon-code"></i></div>
              <div class="item-inner">
                <div class="item-title">关注公众号</div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <!--<div class="list-block" style="display: block;margin-top: -25px;">-->
        <!--<ul>-->
          <!--<li>-->
            <!--<router-link :to="{ name: 'orders' }" class="item-link item-content">-->
              <!--<div class="item-media"><i class="icon icon-app"></i></div>-->
              <!--<div class="item-inner">-->
                <!--<div class="item-title">订单信息</div>-->
              <!--</div>-->
            <!--</router-link>-->
          <!--</li>-->
          <!--<li>-->
            <!--<router-link :to="{ name: 'orderDemo' }" class="item-link item-content">-->
              <!--<div class="item-media"><i class="icon icon-gift"></i></div>-->
              <!--<div class="item-inner">-->
                <!--<div class="item-title">定制填表入口</div>-->
              <!--</div>-->
            <!--</router-link>-->
          <!--</li>-->
        <!--</ul>-->
      <!--</div>-->
      <div class="content-block">
        <a class="button button-big button-fill button-danger external" @click="logout">注销登录</a>
      </div>
      <div style="height: 40px"></div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import {mapMutations, mapState, mapGetters} from 'vuex'
  import EMKT from '../../emkt'

  export default {
    created () {
      this.fetchCoupons()
    },
    watch: {
      'researchGroupDetailList': {
        handler: 'fetchTotalWaitApproveOrder',
        immediate: true
      }
    },
    mounted () {
      this.hasLogin()
    },
    data () {
      return {
        myCoupons: [],
        baseUrl: '/emktResources/resocurces/img/pay/',
        attrurl: '/emktResources/resocurces/img/promotion/',
        totalWaitApproveOrder: 0
      }
    },
    methods: {
      ...mapMutations([
        'LOGIN_STATE_UPDATE', 'CLIENT_INFO_UPDATE', 'MYORDER_UPDATE', 'CLIENT_INFO', 'INIT_MESSAGE', 'UPDATE_SHOWBILLINFO', 'REMOVE_ALL_FROM_CART_LIST'
      ]),
      toOrderDetail (selectId) {
        // if (this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.ssoFlag === 0) {
        //   this.$router.push({name: 'WeappMyOrders'})
        // } else {
        //   this.$router.push({name: 'myOrders', query: {id: selectId}})
        // }
        this.$router.push({name: 'myOrders', query: {id: selectId}})
      },
      toEvaluationOrder () {
        this.$router.push({name: 'evaluation'})
      },
      logout () {
        var _this = this
        _this.gcapi('getRecommendation', 'GUEST').then((res) => {
//                EMKT.setStoreItem('EmktPlain', merchList)
          var i = 0
          var list = []
          var newlist = res.body.result
          if (newlist.length > 15) {
            for (i = 0; i < 15; i++) {
              list.push(newlist[i])
            }
            EMKT.setStoreItem('EmktRecommendations', list)
          } else {
            EMKT.setStoreItem('EmktRecommendations', newlist)
          }
        })
        _this.gcapi('gcwwwifc/userLogout')
          .then((response) => {
            if (response.body.code === 0) {
              $.sign.shareUrl = EMKT.wxShareUrl
              EMKT.wxShare()
//              _this.CLIENT_INFO_UPDATE('')
//              _this.MYORDER_UPDATE('')
//              _this.LOGIN_STATE_UPDATE(false)
//              window.location = window.location.origin
              $.toast('注销成功')
              $.sign.shareUrl = EMKT.wxShareUrl
              EMKT.wxShare()
              _this.CLIENT_INFO_UPDATE('')
              _this.MYORDER_UPDATE('')
              _this.LOGIN_STATE_UPDATE(false)
              _this.gcapi('@gcwwwifc/login', {
                'LoginId': 'guest',
                'Password': 'guest'
              }).then((response) => {
                if (response !== undefined) {
                  let res = response.body.result
                  _this.CLIENT_INFO(res)
                }
              })
              // 客户注销登录 清空cartList
              _this.REMOVE_ALL_FROM_CART_LIST()
              _this.$router.push('/category')
            }
            if (response.body.code === 1) {
              $.toast('失败')
            }
          }, (response) => {
            $.toast('失败，请重试')
          })
      },
      hasLogin () {
        var _this = this
        let guest = _this.sessionInfo
        let customerInfo = _this.sessionInfo.customerInfo
        // console.log(customerInfo)
//        console.log('login state: ' + _this.hasLogin)
        if (guest.customerNo === 'GUEST' || customerInfo === '') {
          _this.$router.push('/login')
        }
      },
      fetchCoupons () {
        var _this = this
        let customerInfo = _this.sessionInfo.customerInfo
        let customerNo = ''
        if (customerInfo) {
          customerNo = customerInfo.customerNo
          var BillInfoBlacklis = EMKT.getLocalStorage('EmktBillInfoBlacklist')
          if (BillInfoBlacklis !== undefined && BillInfoBlacklis !== null) {
            if (BillInfoBlacklis.indexOf(customerNo) !== -1) {
              _this.UPDATE_SHOWBILLINFO(false)
            } else {
              _this.UPDATE_SHOWBILLINFO(true)
            }
          }
          _this.gcapi('getMyCoupons', customerNo).then((res) => {
            EMKT.setLocalStorage('allCoupons', res.body.result)
            // const coupons = []
            // for (let coupon of res.body.result) {
            //   coupon.startDT = coupon.startDT.replace(/-/g, '/')
            //   coupon.endDT = coupon.endDT.replace(/-/g, '/')
            //   if (new Date().getTime() <= new Date(coupon.endDT).getTime()) {
            //     coupons.push(coupon)
            //   }
            // }
            // var specialcouponpromotions = EMKT.getLocalStorage('EmktSpecialcouponpromotions')
            // for (let pro of specialcouponpromotions) {
            //   let endDT = new Date(pro.endDT.year, pro.endDT.month, pro.endDT.dayOfMonth, pro.endDT.hourOfDay, pro.endDT.minute, pro.endDT.second)
            //   let now = new Date()
            //   console.log(endDT, now)
            //   if (now < endDT && pro.promotionCustomer.customerNos.indexOf(customerNo) !== -1) {
            //     var MySpecialPromotionCoupon = {}
            //     _this.gcapi('getMySpecialPromotionCoupon', pro.promotionGuid).then((res) => {
            //       if (res.body.result != null) {
            //         MySpecialPromotionCoupon = res.body.result
            //         var newcoupon = {
            //           'promotionGuid': pro.promotionGuid,
            //           'code': customerNo + MySpecialPromotionCoupon.guid,
            //           'customerNo': customerNo,
            //           'type': 5,
            //           'label': pro.name,
            //           'startDT': pro.startDT,
            //           'endDT': pro.endDT,
            //           'description': pro.description
            //         }
            //         MySpecialPromotionCoupon.quantity < pro.promotionCustomer.quantity ? newcoupon.applied = 0 : newcoupon.applied = 1
            //         if (newcoupon.applied === 0) {
            //           for (var i = 0; i < pro.promotionCustomer.quantity - MySpecialPromotionCoupon.quantity; i++) {
            //             coupons.push(newcoupon)
            //           }
            //         }
            //       } else if (res.body.code === 0) {
            //         var newcoupon1 = {
            //           'promotionGuid': pro.promotionGuid,
            //           'code': customerNo + pro.promotionGuid + customerNo,
            //           'customerNo': customerNo,
            //           'type': 0,
            //           'label': pro.name,
            //           'startDT': pro.startDT,
            //           'endDT': pro.endDT,
            //           'description': pro.description
            //         }
            //         newcoupon1.applied = 0
            //         coupons.push(newcoupon1)
            //       }
            //     })
            //   }
            // }
            _this.myCoupons = res.body.result && res.body.result.filter(coupon => coupon.applied === 0)
//            if (_this.myCoupons.length > 0) {
//              var isread = true
//              for (var i in _this.myCoupons) {
//                if (_this.myCoupons[i].acknowledge === 0) {
//                  isread = false
//                }
//              }
//              if (!isread) {
//                $.modal({
//                  text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
//                  buttons: [{
//                    text: '查看全部优惠券',
//                    onClick: function () {
//                      _this.gcapi('acknowledge', customerNo)
//                        .then((response) => {
//                        })
//                      _this.$router.push({name: 'myCoupons'})
//                    }
//                  }, {
//                    text: '我知道了',
//                    onClick: function () {
//                      _this.gcapi('acknowledge', customerNo)
//                        .then((response) => {
//                        })
//                    }
//                  }]
//                })
//              }
//            }
          })
        }
        _this.INIT_MESSAGE('INIT_MESSAGE')
      },
      gotoMymessage () {
        EMKT.openCustomerService()
//        var _this = this
//        _this.gcapi('retrieveMyLeaveMessages').then((response) => {
//          let data = response.body.result.merchantMessages
//          if (data) {
//            _this.messageSessions[0].merchantMessages = data
//          }
//        })
//         window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
      },
      getPointsDetail () {
        this.$router.push('/PointsDetails')
      },
      getMyAccountChecked () {
        this.$router.push('/user/OldAccountChecked')
      },
      fetchTotalWaitApproveOrder () {
        if (!this.hasLogin) return
        this.gcapi('getWaitingApprovedOrderCount').then(res => {
          if (res && res.body.result) {
            this.totalWaitApproveOrder = res.body.result
          }
        })
      }
    },
    computed: {
      ...mapState([
        'sessionInfo', 'myOrder', 'showBillInfo'
      ]),
      ...mapGetters([
        'curMessageSession', 'isSFFlag', 'researchGroupDetailList'
        // ...
      ]),
      creditPay () {
        let cusInfo = this.sessionInfo.customerInfo
        let isCreditPay = false
        if (cusInfo) {
          let banlance = cusInfo.emktCreditBalance
          let status = cusInfo.payTypeApplyStatusID
          if (banlance && status === 0) {
            isCreditPay = true
          }
        }
        return isCreditPay
      },
      moneyRemain () {
        let cusInfo = this.sessionInfo.customerInfo
        let isMoneyRemain = false
        if (cusInfo) {
          let prepayMoney = cusInfo.prepayMoneyRemain
          if (prepayMoney) {
            isMoneyRemain = true
          }
        }
        return isMoneyRemain
      },
      creditStatus () {
        let cusInfo = this.sessionInfo.customerInfo
        let status = 0
        if (cusInfo) {
          let id = cusInfo.payTypeApplyStatusID
          if (id) {
            status = id
          }
        }
        return status
      },
      payTypeApplyStatus () {
        let cusInfo = this.sessionInfo.customerInfo
        let type = ''
        if (cusInfo) {
          let id = cusInfo.payTypeApplyStatusID
          if (id === 1 || id === 3) {
            type = '信用付申请中'
          }
        }
        return type
      },
      expireInOneDay () {
        const coupons = this.myCoupons
        if (coupons.length === 0) {
          return false
        }
        return coupons.some((coupon) => {
          const endDT = Date.parse(coupon.endDT)
          const now = Date.parse(new Date())
          return endDT - now < 24 * 3600 * 1000
        })
      }
    },
    filters: {
      currencyStyle (val) {
        return val + '元'
      }
    }
  }
</script>

<style scoped>
/*.font-size {*/
  /*font-size: 0.7rem;*/
/*}*/
.border {
  border-left: 1px solid #ccc;
  margin-left: 3.5%;
  margin-top: -0.2rem;
}
.row .col-20 .orderNum {
  position: absolute;
  top:5.8rem;
  color: white;
  background: red;
  border-radius: 0.5rem;
  line-height: 0.4rem;
  font-size: 0.7rem;
  margin-left: 0.1rem;
  padding: 0.3rem;
  height: 1rem
}
.row .col-20 .orderPic {
  margin: 1.2rem 0 0.2rem 0
}
.font-size{
  font-size: 0.6rem;
  margin-top: -0.2rem;
}
  .icon-order {
    width: 1.1rem;
    height: 1.1rem;
  }

  .icon-order-pay {
    width: 2rem;
    margin-top: -0.2rem;
  }
.bar .icon {
  position: relative;
  z-index: 20;
  padding: .5rem .1rem;
  font-size: 1rem;
}
  .unreadmessage {
    position: absolute;
    top:0;
    left:1.7rem;
    color: white;
    background-color: red;
    border-radius: 0.5rem;
    height: 0.8rem;
    width: 0.8rem;
    text-align: center;
    font-size: x-small;
  }
  .wait-approve {
    color: white;
    background: red;
    border-radius: 0.5rem;
    line-height: 0.4rem;
    font-size: 0.7rem;
    margin-left: 0.1rem;
    padding: 0.3rem;
    height: 1rem;
  }
</style>



// WEBPACK FOOTER //
// Me.vue?ba45a89a